// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"def197e7","453":"bfd56f49","958":"56200708"}[chunkId] + ".chunk.js";
};